import React from 'react';
import PropTypes from 'prop-types';

const clickHandler = () => document.location.href = '/my/classrooms/';

/**
 * Button that links the user to the list of all of their classrooms or /my/classrooms/
 */
const GotoAllClassrooms = props => {
	const { btnClass, disabled } = props;

	return (
		<div>
			<button className={'text-center btn ' + btnClass}
			        onClick={clickHandler} disabled={disabled} >Go to Classrooms</button>
		</div>
	);
};

export default GotoAllClassrooms;

GotoAllClassrooms.propTypes = {
	btnClass: PropTypes.string,
	disabled: PropTypes.bool
};
